import { ChangeEvent, FC, useRef } from 'react';
import clsx from 'clsx';
import { TextField, TextFieldProps } from '../TextField';
import SearchIcon from '../../assets/icons/search.svg?react';
import ClearIcon from '../../assets/icons/close_circle.svg?react';

import styles from './SearchField.module.css';
import { useIntl } from 'react-intl';

interface SearchFieldProps extends TextFieldProps {}

export const SearchField: FC<SearchFieldProps> = ({ className, ...props }) => {
  const { onChange, value } = props;
  const { $t } = useIntl();
  const ref = useRef<HTMLInputElement>(null);

  const onClear = () => {
    onChange?.({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
    ref.current?.focus();
  };

  return (
    <TextField
      ref={ref}
      className={clsx(styles.input, className)}
      type="text"
      placeholder={$t({ id: 'Search' })}
      {...props}
    >
      <div className={clsx(styles.iconContainer, styles.searchContainer)}>
        <SearchIcon className={styles.icon} />
      </div>
      {value !== '' && (
        <div
          className={clsx(styles.iconContainer, styles.clearContainer)}
          onClick={onClear}
          data-testid="clear-search"
        >
          <ClearIcon className={styles.icon} />
        </div>
      )}
    </TextField>
  );
};
